import { CSSProperties, memo, ReactNode } from "react";
import { enums } from "../../../shared";
import { useClassNames } from "../../../shared/hooks";

import styles from "./styles.module.scss";

type HeadingType = {
  size?: enums.SIZE;
  children: ReactNode;
  color?: "gray" | "black";
  sx?: CSSProperties;
  className?: string;
};

const Heading = ({
  size = enums.SIZE.MD,
  children,
  color = "black",
  sx,
  className,
}: HeadingType) => {
  const classNames = useClassNames([
    styles.Heading,
    className ? className : "",
    styles[`Heading--${size}`],
    styles[`Heading--${color}`],
  ]);

  return (
    <h1 style={sx} className={classNames}>
      {children}
    </h1>
  );
};

export default memo(Heading);
